import React from "react";
import { Routes, Route, Link, NavLink } from "react-router-dom";
import "./App.css";
import emailjs from "@emailjs/browser";
// Import team image
import teamImage from "./images/team-programmers-talking-about-algorithm-running-laptop-screen-pointing-source-code-while-sitting-desk-software-developers-collaborating-data-coding-group-project.jpg";
// Import logos
import logoImage from "./images/2.png";
import logoImageLight from "./images/1.png";

// Translation object
const translations = {
  en: {
    home: "Home",
    about: "About",
    services: "Services",
    contact: "Contact",
    projects: "Projects",
    templates: "Templates",
    heroTitle: "AI-Powered Automation & Intelligent Solutions",
    heroSubtitle:
      "Transform your business with AI automation and intelligent workflows. We deliver real results through AI-first solutions.",
    getAISolutions: "Get AI Solutions",
    viewAIProjects: "View AI Projects",
    aboutTitle: "About Valcoda - AI Automation & Intelligent Solutions Leader",
    aboutText:
      "Founded in 2025 in Cyprus, Valcoda is a pioneering AI automation and intelligent solutions company. We specialize in transforming businesses through cutting-edge AI technologies, workflow automation, and intelligent software systems. Our expertise in AI-first development, combined with traditional web development capabilities, enables us to deliver comprehensive digital transformation solutions that drive real business value and competitive advantage.",
    aiSolutionsDelivered: "AI Solutions Delivered",
    automationEfficiency: "Automation Efficiency",
    aiFirstApproach: "AI-First Approach",
    servicesTitle: "AI-First Solutions & Intelligent Automation",
    servicesSubtitle:
      "We specialize in AI automation and intelligent solutions as our core expertise, with traditional web development as a supporting capability. Our AI-first approach ensures every solution is optimized for intelligence, automation, and maximum business impact.",
    contactTitle: "Contact Us",
    getInTouch: "Get in Touch",
    email: "Email:",
    phone: "Phone:",
    location: "Location:",
    readyToStart:
      "Ready to start your next project? Send us a message and we'll get back to you within 24 hours.",
    sendEmail: "Send Email",
    sending: "Sending...",
    messageSent: "Message sent successfully! We'll get back to you soon.",
    messageFailed:
      "Failed to send message. Please try again or contact us directly at info@valcoda.com",
    yourName: "Your name",
    yourEmail: "Your email",
    howCanWeHelp: "How can we help?",
    termsAndConditions: "Terms and Conditions",
  },
  tr: {
    home: "Ana Sayfa",
    about: "Hakkımızda",
    services: "Hizmetler",
    contact: "İletişim",
    projects: "Projeler",
    templates: "Şablonlar",
    heroTitle: "AI Destekli Otomasyon ve Akıllı Çözümler",
    heroSubtitle:
      "İşinizi AI otomasyonu ve akıllı iş akışları ile dönüştürün. AI-öncelikli çözümlerle gerçek sonuçlar sunuyoruz.",
    getAISolutions: "AI Çözümleri Al",
    viewAIProjects: "AI Projelerini Görüntüle",
    aboutTitle: "Valcoda Hakkında - AI Otomasyon ve Akıllı Çözümler Lideri",
    aboutText:
      "2025 yılında Kıbrıs'ta kurulan Valcoda, öncü AI otomasyon ve akıllı çözümler şirketidir. İşletmeleri en son AI teknolojileri, iş akışı otomasyonu ve akıllı yazılım sistemleri ile dönüştürmede uzmanız. AI-öncelikli geliştirme uzmanlığımız, geleneksel web geliştirme yeteneklerimizle birleşerek, gerçek iş değeri ve rekabet avantajı sağlayan kapsamlı dijital dönüşüm çözümleri sunmamızı sağlar.",
    aiSolutionsDelivered: "Teslim Edilen AI Çözümleri",
    automationEfficiency: "Otomasyon Verimliliği",
    aiFirstApproach: "AI-Öncelikli Yaklaşım",
    servicesTitle: "AI-Öncelikli Çözümler ve Akıllı Otomasyon",
    servicesSubtitle:
      "AI otomasyon ve akıllı çözümleri temel uzmanlığımız olarak, geleneksel web geliştirmeyi destekleyici yetenek olarak uzmanlaşıyoruz. AI-öncelikli yaklaşımımız, her çözümün zeka, otomasyon ve maksimum iş etkisi için optimize edilmesini sağlar.",
    contactTitle: "Bizimle İletişime Geçin",
    getInTouch: "İletişime Geçin",
    email: "E-posta:",
    phone: "Telefon:",
    location: "Konum:",
    readyToStart:
      "Bir sonraki projenize başlamaya hazır mısınız? Bize mesaj gönderin, 24 saat içinde size dönüş yapalım.",
    sendEmail: "E-posta Gönder",
    sending: "Gönderiliyor...",
    messageSent: "Mesaj başarıyla gönderildi! Yakında size dönüş yapacağız.",
    messageFailed:
      "Mesaj gönderilemedi. Lütfen tekrar deneyin veya doğrudan info@valcoda.com adresinden bizimle iletişime geçin.",
    yourName: "Adınız",
    yourEmail: "E-posta adresiniz",
    howCanWeHelp: "Nasıl yardımcı olabiliriz?",
    termsAndConditions: "Şartlar ve Koşullar",
  },
  el: {
    home: "Αρχική",
    about: "Σχετικά",
    services: "Υπηρεσίες",
    contact: "Επικοινωνία",
    projects: "Έργα",
    templates: "Πρότυπα",
    heroTitle: "AI-Τροφοδοτούμενη Αυτοματοποίηση και Έξυπνες Λύσεις",
    heroSubtitle:
      "Μεταμορφώστε την επιχείρησή σας με AI αυτοματοποίηση και έξυπνες ροές εργασίας. Παράγουμε πραγματικά αποτελέσματα μέσω AI-πρώτων λύσεων.",
    getAISolutions: "Λάβετε AI Λύσεις",
    viewAIProjects: "Δείτε AI Έργα",
    aboutTitle:
      "Σχετικά με την Valcoda - Ηγέτης AI Αυτοματοποίησης και Έξυπνων Λύσεων",
    aboutText:
      "Ιδρυμένη το 2025 στην Κύπρο, η Valcoda είναι μια πρωτοπόρος εταιρεία AI αυτοματοποίησης και έξυπνων λύσεων. Ειδικευόμαστε στη μεταμόρφωση επιχειρήσεων μέσω cutting-edge AI τεχνολογιών, αυτοματοποίησης ροών εργασίας και έξυπνων συστημάτων λογισμικού. Η εμπειρία μας στην AI-πρώτη ανάπτυξη, σε συνδυασμό με τις παραδοσιακές δυνατότητες ανάπτυξης ιστού, μας επιτρέπει να παρέχουμε ολοκληρωμένες λύσεις ψηφιακής μεταμόρφωσης που οδηγούν σε πραγματική επιχειρηματική αξία και ανταγωνιστικό πλεονέκτημα.",
    aiSolutionsDelivered: "Παραδομένες AI Λύσεις",
    automationEfficiency: "Αποδοτικότητα Αυτοματοποίησης",
    aiFirstApproach: "AI-Πρώτη Προσέγγιση",
    servicesTitle: "AI-Πρώτες Λύσεις και Έξυπνη Αυτοματοποίηση",
    servicesSubtitle:
      "Ειδικευόμαστε στην AI αυτοματοποίηση και έξυπνες λύσεις ως βασική εμπειρία μας, με την παραδοσιακή ανάπτυξη ιστού ως υποστηρικτική ικανότητα. Η AI-πρώτη προσέγγισή μας διασφαλίζει ότι κάθε λύση είναι βελτιστοποιημένη για νοημοσύνη, αυτοματοποίηση και μέγιστη επιχειρηματική επίδραση.",
    contactTitle: "Επικοινωνήστε μαζί μας",
    getInTouch: "Επικοινωνήστε",
    email: "Email:",
    phone: "Τηλέφωνο:",
    location: "Τοποθεσία:",
    readyToStart:
      "Έτοιμοι να ξεκινήσετε το επόμενο σας έργο; Στείλτε μας ένα μήνυμα και θα σας απαντήσουμε εντός 24 ωρών.",
    sendEmail: "Στείλε Email",
    sending: "Αποστολή...",
    messageSent: "Το μήνυμα στάλθηκε επιτυχώς! Θα σας απαντήσουμε σύντομα.",
    messageFailed:
      "Αποτυχία αποστολής μηνύματος. Παρακαλώ δοκιμάστε ξανά ή επικοινωνήστε μαζί μας απευθείας στο info@valcoda.com",
    yourName: "Το όνομά σας",
    yourEmail: "Το email σας",
    howCanWeHelp: "Πώς μπορούμε να βοηθήσουμε;",
    termsAndConditions: "Όροι και Προϋποθέσεις",
  },
  es: {
    home: "Inicio",
    about: "Acerca de",
    services: "Servicios",
    contact: "Contacto",
    projects: "Proyectos",
    templates: "Plantillas",
    heroTitle: "Automatización Impulsada por IA y Soluciones Inteligentes",
    heroSubtitle:
      "Transforma tu negocio con automatización de IA y flujos de trabajo inteligentes. Entregamos resultados reales a través de soluciones centradas en IA.",
    getAISolutions: "Obtener Soluciones de IA",
    viewAIProjects: "Ver Proyectos de IA",
    aboutTitle:
      "Acerca de Valcoda - Líder en Automatización de IA y Soluciones Inteligentes",
    aboutText:
      "Fundada en 2025 en Chipre, Valcoda es una empresa pionera en automatización de IA y soluciones inteligentes. Nos especializamos en transformar negocios a través de tecnologías de IA de vanguardia, automatización de flujos de trabajo y sistemas de software inteligentes. Nuestra experiencia en desarrollo centrado en IA, combinada con capacidades tradicionales de desarrollo web, nos permite entregar soluciones integrales de transformación digital que impulsan valor comercial real y ventaja competitiva.",
    aiSolutionsDelivered: "Soluciones de IA Entregadas",
    automationEfficiency: "Eficiencia de Automatización",
    aiFirstApproach: "Enfoque Centrado en IA",
    servicesTitle: "Soluciones Centradas en IA y Automatización Inteligente",
    servicesSubtitle:
      "Nos especializamos en automatización de IA y soluciones inteligentes como nuestra experiencia central, con desarrollo web tradicional como capacidad de soporte. Nuestro enfoque centrado en IA asegura que cada solución esté optimizada para inteligencia, automatización y máximo impacto comercial.",
    contactTitle: "Contáctanos",
    getInTouch: "Ponte en Contacto",
    email: "Email:",
    phone: "Teléfono:",
    location: "Ubicación:",
    readyToStart:
      "¿Listo para comenzar tu próximo proyecto? Envíanos un mensaje y te responderemos dentro de 24 horas.",
    sendEmail: "Enviar Email",
    sending: "Enviando...",
    messageSent: "¡Mensaje enviado exitosamente! Te responderemos pronto.",
    messageFailed:
      "Error al enviar mensaje. Por favor intenta de nuevo o contáctanos directamente en info@valcoda.com",
    yourName: "Tu nombre",
    yourEmail: "Tu email",
    howCanWeHelp: "¿Cómo podemos ayudar?",
    termsAndConditions: "Términos y Condiciones",
  },
};

function Home({ t }) {
  return (
    <div>
      <section
        className="sb-hero"
        style={{
          backgroundImage: `url(${teamImage})`,
        }}
      >
        <div>
          <h1>{t.heroTitle}</h1>
          <p
            style={{
              fontSize: "20px",
              marginBottom: "32px",
              color: "rgba(255, 255, 255, 0.9)",
              maxWidth: "600px",
              lineHeight: "1.5",
            }}
          >
            {t.heroSubtitle}
          </p>
          <div className="sb-cta-row">
            <a className="sb-btn sb-btn-primary" href="#contact">
              {t.getAISolutions}
            </a>
            <Link className="sb-btn sb-btn-ghost" to="/projects">
              {t.viewAIProjects}
            </Link>
          </div>
        </div>
      </section>

      <main>
        <section className="sb-section" id="about">
          <h2>{t.aboutTitle}</h2>
          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.6",
              color: "var(--muted)",
            }}
          >
            {t.aboutText}
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "24px",
              marginTop: "32px",
            }}
          >
            <div>
              <h3 style={{ color: "var(--blue)", marginBottom: "8px" }}>50+</h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                {t.aiSolutionsDelivered}
              </p>
            </div>
            <div>
              <h3 style={{ color: "var(--blue)", marginBottom: "8px" }}>95%</h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                {t.automationEfficiency}
              </p>
            </div>
            <div>
              <h3 style={{ color: "var(--blue)", marginBottom: "8px" }}>
                100%
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                {t.aiFirstApproach}
              </p>
            </div>
          </div>
        </section>

        <section className="sb-section" id="services">
          <h2>{t.servicesTitle}</h2>
          <p
            style={{
              fontSize: "18px",
              lineHeight: "1.6",
              color: "var(--muted)",
              textAlign: "center",
              marginBottom: "32px",
              maxWidth: "800px",
              margin: "0 auto 32px auto",
            }}
          >
            {t.servicesSubtitle}
          </p>
          <div className="sb-grid">
            <div
              className="sb-card"
              style={{
                border: "2px solid var(--blue)",
                background: "rgba(59, 130, 246, 0.05)",
              }}
            >
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                🤖 AI Automation (n8n)
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                <strong>Our Core Expertise:</strong> Advanced workflow
                automation using n8n platform to streamline business processes,
                integrate systems, and eliminate manual work through intelligent
                automation solutions.
              </p>
            </div>
            <div
              className="sb-card"
              style={{
                border: "2px solid var(--blue)",
                background: "rgba(59, 130, 246, 0.05)",
              }}
            >
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                🧠 AI Consultancy & Solutions
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                <strong>Strategic AI Implementation:</strong> Machine learning
                model development, AI integration services, and intelligent
                system design to transform your business with cutting-edge
                artificial intelligence.
              </p>
            </div>
            <div className="sb-card">
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                🚀 Intelligent SaaS Platforms
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                AI-powered SaaS solutions with intelligent automation, smart
                analytics, and automated decision-making capabilities built into
                scalable cloud platforms.
              </p>
            </div>
            <div className="sb-card">
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                🔄 Smart Digital Transformation
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                AI-driven digital transformation including intelligent process
                optimization, automated workflows, and smart business ecosystem
                modernization.
              </p>
            </div>
            <div className="sb-card">
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                💻 Web Development (Supporting Service)
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                Traditional web development capabilities including React,
                Node.js, and modern frameworks - supporting our AI solutions
                with robust, scalable web platforms.
              </p>
            </div>
            <div className="sb-card">
              <h3 style={{ color: "var(--blue)", marginBottom: "12px" }}>
                ☁️ AI-Optimized Cloud Infrastructure
              </h3>
              <p style={{ margin: 0, color: "var(--muted)" }}>
                Cloud infrastructure specifically designed for AI workloads,
                machine learning pipelines, and intelligent automation with AWS,
                Azure, and GCP.
              </p>
            </div>
          </div>
        </section>

        <section className="sb-section" id="contact">
          <h2>{t.contactTitle}</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "48px",
              alignItems: "start",
            }}
          >
            <div>
              <h3 style={{ color: "var(--blue)", marginBottom: "16px" }}>
                {t.getInTouch}
              </h3>
              <ul
                style={{ listStyle: "none", padding: 0, marginBottom: "24px" }}
              >
                <li style={{ marginBottom: "12px" }}>
                  <strong style={{ color: "var(--text)" }}>📧 {t.email}</strong>
                  <span style={{ color: "var(--muted)", marginLeft: "8px" }}>
                    info@valcoda.com
                  </span>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <strong style={{ color: "var(--text)" }}>📞 {t.phone}</strong>
                  <span style={{ color: "var(--muted)", marginLeft: "8px" }}>
                    +357 99 103530
                  </span>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <strong style={{ color: "var(--text)" }}>
                    📍 {t.location}
                  </strong>
                  <span style={{ color: "var(--muted)", marginLeft: "8px" }}>
                    Remote
                  </span>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://www.instagram.com/valcoda_ai/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      textDecoration: "none",
                      color: "var(--text)",
                    }}
                  >
                    <strong style={{ color: "var(--text)", display: "inline-flex", alignItems: "center", gap: "8px" }}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        style={{ verticalAlign: "middle" }}
                      >
                        <defs>
                          <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stopColor="#833AB4" />
                            <stop offset="50%" stopColor="#FD1D1D" />
                            <stop offset="100%" stopColor="#FCAF45" />
                          </linearGradient>
                        </defs>
                        <path
                          d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                          fill="url(#instagram-gradient)"
                        />
                      </svg>
                      Valcoda
                    </strong>
                  </a>
                </li>
              </ul>
              <p style={{ color: "var(--muted)", lineHeight: "1.6" }}>
                {t.readyToStart}
              </p>
            </div>
            <ContactForm t={t} />
          </div>
        </section>
      </main>
    </div>
  );
}

function Projects() {
  // Scroll animation for project cards
  React.useEffect(() => {
    // Reset all animations first
    const allCards = document.querySelectorAll(".sb-card");
    allCards.forEach((card) => {
      card.classList.remove("animate");
    });

    // Only apply animations on desktop
    if (window.innerWidth > 768) {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      }, observerOptions);

      const cards = document.querySelectorAll(".sb-card");
      cards.forEach((card) => {
        observer.observe(card);
      });

      return () => {
        cards.forEach((card) => {
          observer.unobserve(card);
        });
      };
    }
  }, []);

  const projects = [
    {
      name: "ChatBoots",
      description:
        "AI-powered chatbot platform for businesses with natural language processing and automated customer support capabilities.",
      image:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070&auto=format&fit=crop",
      url: "https://chatboots.com/",
      features: [
        "AI Chatbot",
        "Natural Language Processing",
        "Customer Support",
        "Analytics Dashboard",
        "Multi-language Support",
      ],
      tech: ["React", "Node.js", "OpenAI API", "MongoDB", "WebSocket"],
    },
    {
      name: "ONOX",
      description:
        "Digital agency specializing in web design, development, and branding with modern UI/UX solutions.",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
      url: "https://onox.webflow.io/",
      features: [
        "Web Design",
        "Brand Identity",
        "UI/UX Design",
        "Responsive Design",
        "SEO Optimization",
      ],
      tech: ["Webflow", "Figma", "JavaScript", "CSS3", "HTML5"],
    },
  ];

  return (
    <main>
      <h1>Projects</h1>
      <div className="sb-grid">
        {projects.map((p) => (
          <article key={p.name} className="sb-card">
            {p.image && <img src={p.image} alt={p.name} loading="lazy" />}

            <div style={{ padding: "20px" }}>
              <h3 style={{ margin: "0 0 12px 0", color: "var(--blue)" }}>
                {p.url ? (
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "var(--blue)", textDecoration: "none" }}
                  >
                    {p.name}
                  </a>
                ) : (
                  p.name
                )}
              </h3>

              <p style={{ margin: "0 0 16px 0", color: "var(--muted)" }}>
                {p.description}
              </p>

              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "14px",
                    color: "var(--text)",
                  }}
                >
                  Key Features:
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {p.features.map((feature, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "var(--panel)",
                        color: "var(--muted)",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                        border: "1px solid var(--border)",
                      }}
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "14px",
                    color: "var(--text)",
                  }}
                >
                  Tech Stack:
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {p.tech.map((tech, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "var(--blue)",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}

function Terms() {
  return (
    <main style={{ maxWidth: "800px", margin: "0 auto", padding: "24px 16px" }}>
      <h1>Terms and Conditions</h1>
      <p style={{ color: "var(--muted)", marginBottom: "32px" }}>
        Last updated: {new Date().toLocaleDateString()}
      </p>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          1. Acceptance of Terms
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          By accessing and using Valcoda services, you accept and agree to be
          bound by the terms and provision of this agreement.
        </p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          2. Services
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          Valcoda provides web development, mobile application development,
          cloud solutions, and UI/UX design services. All services are provided
          subject to these terms.
        </p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          3. Intellectual Property
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          All intellectual property rights in the services and any content
          delivered remain the property of Valcoda unless otherwise agreed in
          writing.
        </p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          4. Payment Terms
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          Payment terms will be specified in individual project agreements. Late
          payments may incur additional charges as specified in the project
          contract.
        </p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          5. Limitation of Liability
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          Valcoda's liability is limited to the amount paid for services. We are
          not liable for any indirect, incidental, or consequential damages.
        </p>
      </section>

      <section style={{ marginBottom: "32px" }}>
        <h2 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          6. Contact Information
        </h2>
        <p style={{ lineHeight: "1.6", color: "var(--muted)" }}>
          For questions about these Terms and Conditions, please contact us at
          info@valcoda.com
        </p>
      </section>
    </main>
  );
}

function TemplateProjects() {
  // Scroll animation for template cards
  React.useEffect(() => {
    // Reset all animations first
    const allCards = document.querySelectorAll(".sb-card");
    allCards.forEach((card) => {
      card.classList.remove("animate");
    });

    // Only apply animations on desktop
    if (window.innerWidth > 768) {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      }, observerOptions);

      const cards = document.querySelectorAll(".sb-card");
      cards.forEach((card) => {
        observer.observe(card);
      });

      return () => {
        cards.forEach((card) => {
          observer.unobserve(card);
        });
      };
    }
  }, []);

  const templateProjects = [
    {
      name: "AI Chatbot Platform Template",
      description:
        "Complete AI chatbot solution with natural language processing, conversation management, analytics dashboard, and multi-channel integration. Built with OpenAI API and advanced NLP capabilities.",
      image:
        "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
      features: [
        "AI Conversation Engine",
        "Natural Language Processing",
        "Multi-Channel Support",
        "Analytics Dashboard",
        "Custom Training Models",
      ],
      tech: ["React", "Node.js", "OpenAI API", "MongoDB", "WebSocket"],
      price: "$4,999",
      demoUrl: "#",
      category: "AI Chatbot",
    },
    {
      name: "AI Automation Dashboard Template",
      description:
        "Intelligent automation platform with workflow builder, AI decision engine, process optimization, and real-time monitoring. Perfect for business process automation and intelligent operations.",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
      features: [
        "Visual Workflow Builder",
        "AI Decision Engine",
        "Process Optimization",
        "Real-time Monitoring",
        "Integration Hub",
      ],
      tech: ["Next.js", "TypeScript", "n8n", "PostgreSQL", "Redis"],
      price: "$6,999",
      demoUrl: "#",
      category: "AI Automation",
    },
    {
      name: "AI Analytics Platform Template",
      description:
        "Advanced AI-powered analytics platform with predictive modeling, intelligent insights, automated reporting, and machine learning capabilities. Ideal for data-driven businesses and AI-first companies.",
      image:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070&auto=format&fit=crop",
      features: [
        "Predictive Analytics",
        "Intelligent Insights",
        "Automated Reporting",
        "ML Model Training",
        "Real-time Dashboards",
      ],
      tech: ["React", "Python", "TensorFlow", "PostgreSQL", "Docker"],
      price: "$7,999",
      demoUrl: "#",
      category: "AI Analytics",
    },
  ];

  return (
    <main>
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <h1>Template Projects</h1>
        <p
          style={{
            fontSize: "18px",
            color: "var(--muted)",
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.6",
          }}
        >
          Ready-to-use project templates that you can customize and deploy.
          Perfect for rapid prototyping and getting your ideas to market faster.
        </p>
      </div>

      <div className="sb-grid">
        {templateProjects.map((template, index) => (
          <article
            key={template.name}
            className="sb-card"
            style={{ position: "relative" }}
          >
            {template.image && (
              <img
                src={template.image}
                alt={template.name}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px 8px 0 0",
                }}
              />
            )}

            <div style={{ padding: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "12px",
                }}
              >
                <h3 style={{ margin: "0", color: "var(--blue)" }}>
                  {template.name}
                </h3>
                <span
                  style={{
                    background: "var(--blue)",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {template.category}
                </span>
              </div>

              <p style={{ margin: "0 0 16px 0", color: "var(--muted)" }}>
                {template.description}
              </p>

              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "14px",
                    color: "var(--text)",
                  }}
                >
                  Key Features:
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {template.features.map((feature, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "var(--panel)",
                        color: "var(--muted)",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                        border: "1px solid var(--border)",
                      }}
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: "16px" }}>
                <h4
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "14px",
                    color: "var(--text)",
                  }}
                >
                  Tech Stack:
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {template.tech.map((tech, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "var(--blue)",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                      }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "48px",
          padding: "32px",
          background: "var(--panel)",
          borderRadius: "12px",
          border: "1px solid var(--border)",
        }}
      >
        <h3 style={{ color: "var(--blue)", marginBottom: "16px" }}>
          Need a Custom Template?
        </h3>
        <p style={{ color: "var(--muted)", marginBottom: "24px" }}>
          We can create custom templates tailored to your specific needs and
          requirements.
        </p>
        <a
          href="/#contact"
          className="sb-btn sb-btn-primary"
          style={{ textDecoration: "none" }}
        >
          Contact Us for Custom Templates
        </a>
      </div>
    </main>
  );
}

function ContactForm({ t }) {
  const [form, setForm] = React.useState({ name: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitStatus, setSubmitStatus] = React.useState("");

  function handleChange(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    // EmailJS configuration
    const serviceId = "service_wxi3m2f";
    const templateId = "template_h7vplid";
    const publicKey = "BL1C7r0Pbmxi3SW0X";

    const templateParams = {
      from_name: form.name,
      from_email: form.email,
      message: form.message,
      to_email: "info@valcoda.com",
      reply_to: form.email,
    };

    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log("Email sent successfully:", response);
        setSubmitStatus(t.messageSent);
        setForm({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
        setSubmitStatus(t.messageFailed);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: 16, maxWidth: 520 }}>
      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        <input
          type="text"
          name="name"
          placeholder={t.yourName}
          value={form.name}
          onChange={handleChange}
          required
          style={{ flex: 1, padding: 10 }}
        />
        <input
          type="email"
          name="email"
          placeholder={t.yourEmail}
          value={form.email}
          onChange={handleChange}
          required
          style={{ flex: 1, padding: 10 }}
        />
      </div>
      <textarea
        name="message"
        placeholder={t.howCanWeHelp}
        value={form.message}
        onChange={handleChange}
        rows={6}
        required
        style={{ width: "100%", padding: 10 }}
      />
      <div style={{ marginTop: 12 }}>
        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            opacity: isSubmitting ? 0.6 : 1,
            cursor: isSubmitting ? "not-allowed" : "pointer",
          }}
        >
          {isSubmitting ? t.sending : t.sendEmail}
        </button>
        {submitStatus && (
          <p
            style={{
              marginTop: "8px",
              color: submitStatus.includes("successfully")
                ? "var(--blue)"
                : "var(--muted)",
              fontSize: "14px",
            }}
          >
            {submitStatus}
          </p>
        )}
      </div>
    </form>
  );
}

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [isDarkMode, setIsDarkMode] = React.useState(() => {
    // Check localStorage first, then system preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme === "dark";
    }
    // Default to dark mode for AI automation company
    return true;
  });
  const [language, setLanguage] = React.useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage || "en";
  });

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem("theme", newTheme ? "dark" : "light");
    document.documentElement.setAttribute(
      "data-theme",
      newTheme ? "dark" : "light"
    );
  };

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
  };

  // Get current translations
  const t = translations[language];

  // Apply theme on mount and when it changes
  React.useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
  }, [isDarkMode]);

  // Scroll animation effect
  React.useEffect(() => {
    // Reset all animations first
    const allElements = document.querySelectorAll(
      ".sb-section, .sb-hero, .sb-card"
    );
    allElements.forEach((element) => {
      element.classList.remove("animate");
    });

    // Only apply animations on desktop
    if (window.innerWidth > 768) {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      }, observerOptions);

      // Observe all sections and cards
      const sections = document.querySelectorAll(
        ".sb-section, .sb-hero, .sb-card"
      );
      sections.forEach((section) => {
        observer.observe(section);
      });

      // Animate hero section immediately on load
      const hero = document.querySelector(".sb-hero");
      if (hero) {
        setTimeout(() => {
          hero.classList.add("animate");
        }, 100);
      }

      return () => {
        sections.forEach((section) => {
          observer.unobserve(section);
        });
      };
    }
  }, []);

  return (
    <div
      className="App"
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <nav
        className="sb-nav"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "16px 24px",
          position: "relative",
        }}
      >
        <Link
          to="/"
          className="sb-brand"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            position: "absolute",
            left: "24px",
          }}
        >
          <img
            src={isDarkMode ? logoImage : logoImageLight}
            alt="Valcoda Logo"
            style={{
              width: "32px",
              height: "32px",
            }}
          />
          <span
            style={{
              fontFamily: "'Courier New', 'Monaco', monospace",
              letterSpacing: "1px",
              fontWeight: "bold",
            }}
          >
            VALCODA
          </span>
        </Link>
        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
            background: "rgba(59, 130, 246, 0.05)",
            padding: "8px",
            borderRadius: "12px",
            border: "1px solid rgba(59, 130, 246, 0.1)",
          }}
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive ? "sb-link sb-link-active" : "sb-link"
            }
          >
            {t.home}
          </NavLink>
          <a href="/#about" className="sb-link">
            {t.about}
          </a>
          <a href="/#services" className="sb-link">
            {t.services}
          </a>
          <a href="/#contact" className="sb-link">
            {t.contact}
          </a>
          <NavLink
            to="/projects"
            className={({ isActive }) =>
              isActive ? "sb-link sb-link-active" : "sb-link"
            }
          >
            {t.projects}
          </NavLink>
          <NavLink
            to="/templates"
            className={({ isActive }) =>
              isActive ? "sb-link sb-link-active" : "sb-link"
            }
          >
            {t.templates}
          </NavLink>
          <div className="language-selector">
            <select
              value={language}
              onChange={(e) => changeLanguage(e.target.value)}
              title="Select Language"
            >
              <option value="en">🇺🇸 EN</option>
              <option value="tr">🇹🇷 TR</option>
              <option value="el">🇬🇷 EL</option>
              <option value="es">🇪🇸 ES</option>
            </select>
          </div>
          <div
            className="theme-toggle"
            onClick={toggleTheme}
            title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          >
            <span className="theme-toggle-icon">
              {isDarkMode ? "🌙" : "☀️"}
            </span>
            <div className="theme-toggle-switch"></div>
          </div>
        </div>

        <button
          className={`sb-burger ${isMobileMenuOpen ? "active" : ""}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="sb-burger-line"></span>
          <span className="sb-burger-line"></span>
          <span className="sb-burger-line"></span>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`sb-mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            isActive ? "sb-link sb-link-active" : "sb-link"
          }
          onClick={closeMobileMenu}
        >
          {t.home}
        </NavLink>
        <a href="/#about" className="sb-link" onClick={closeMobileMenu}>
          {t.about}
        </a>
        <a href="/#services" className="sb-link" onClick={closeMobileMenu}>
          {t.services}
        </a>
        <a href="/#contact" className="sb-link" onClick={closeMobileMenu}>
          {t.contact}
        </a>
        <NavLink
          to="/projects"
          className={({ isActive }) =>
            isActive ? "sb-link sb-link-active" : "sb-link"
          }
          onClick={closeMobileMenu}
        >
          {t.projects}
        </NavLink>
        <NavLink
          to="/templates"
          className={({ isActive }) =>
            isActive ? "sb-link sb-link-active" : "sb-link"
          }
          onClick={closeMobileMenu}
        >
          {t.templates}
        </NavLink>
        <div className="language-selector mobile-language-selector">
          <select
            value={language}
            onChange={(e) => changeLanguage(e.target.value)}
            title="Select Language"
          >
            <option value="en">🇺🇸 EN</option>
            <option value="tr">🇹🇷 TR</option>
            <option value="el">🇬🇷 EL</option>
            <option value="es">🇪🇸 ES</option>
          </select>
        </div>
        <div
          className="theme-toggle mobile-theme-toggle"
          onClick={toggleTheme}
          title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          <span className="theme-toggle-icon">{isDarkMode ? "🌙" : "☀️"}</span>
          <div className="theme-toggle-switch"></div>
        </div>
      </div>
      <div style={{ flex: 1, padding: 16 }}>
        <Routes>
          <Route path="/" element={<Home t={t} />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/templates" element={<TemplateProjects />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </div>
      <footer
        style={{
          padding: 16,
          borderTop: "1px solid var(--border)",
          fontSize: 14,
          background: "var(--panel)",
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: "8px" }}>
          © {new Date().getFullYear()} Valcoda
        </div>
        <div>
          <Link
            to="/terms"
            style={{ color: "var(--muted)", textDecoration: "none" }}
          >
            {t.termsAndConditions}
          </Link>
        </div>
      </footer>
    </div>
  );
}

export default App;
